<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base class="cart-overview" :busy="busy">
        <template v-slot:default="props">
            <pb-body>
                <template slot="title">
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-center">
                            <h3>{{page.contentDataSet.title.value}}</h3>
                            <hr/>
                        </b-col>
                    </b-row>
                </template>
                <template slot="body">
                    <b-container>
                        <b-row class="text-center">
                            <b-col v-if="state === 'SUCCESS'" v-html="page.contentDataSet.content.value">
                            </b-col>
                            <b-col v-else-if="state === 'FAILED'">
                                <p>An Error occured</p>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>
    import UserApi from "@shared/_api/user";
    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'activation',
        data: function () {
            return {
                busy: false,
                page: null,
                state: null
            }
        },
        components: {},
        created() {
            let token = this.$route.params.token;
            this.busy = true;
            ContentAPI.fetchPageByName("user-activation").then(result => {
                this.page = result;
            }).then(() => {
                return UserApi.activate(token).then(() => {
                    this.state = 'SUCCESS';
                })
            }).catch(() => {
                this.state = 'FAILED';
            }).finally(() => {
                this.busy = false;
            })
        }
    }
</script>
